import CoordinatorElement from './CoordinatorElement.vue';
export default CoordinatorElement;


// WEBPACK FOOTER //
// ./src/components/parts/footer/coordinators/element/index.ts